import CardQueueDataGrid from "../CardQueueDataGrid";
import moment from "moment";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import DialogUpdateBrightreeStopHold from "../../../Dialog/DialogUpdateBrightreeStopHold";
import Calendar from "../../../../Utility/Calendar";
import api from "../../../../Seating/Security/api";


export default class CardQueueDataGridBrightreeStopHold extends CardQueueDataGrid {
    columns = {
        "brightree_stop_hold.id": {
            type: "number",
            name: "ID",
            width: 110,
        },
        "brightree_stop_hold.order_activity.id": {
            type: "number",
            name: "Order #",
            width: 110,
        },
        "brightree_stop_hold.brightree_stop_hold_type_term_id": {
            type: "term",
            name: "Type",
            width: 90,
        },
        "brightree_stop_hold.brightree_stop_hold_reason_term_id": {
            type: "term",
            name: "Reason",
            width: 170,
        },
        "brightree_stop_hold.followup_date": {
            type: "date",
            name: "F/U Date",
            width: 110,
        },
        "brightree_stop_hold.sales_order_id": {
            type: "number",
            name: "BT Order ID",
            width: 120,
        },
        "brightree_stop_hold._queue_age": {
            type: "ageDays",
            name: "Age",
            width: 70,
        },
        "brightree_stop_hold._queue_entered_date": {
            type: "date",
            name: "",
            width: 110,
        },
        "brightree_stop_hold.allowable_amount": {
            type: "currency",
            name: "Allowable",
            align: "right",
            width: 120,
        },
        "brightree_stop_hold.charge_amount": {
            type: "currency",
            name: "Charge",
            align: "right",
            width: 120,
        },
        "brightree_stop_hold.created_at": {
            type: "date",
            name: "Created At",
            width: 140,
        },
        "brightree_stop_hold.order_activity.activity.owner_id": {
            type: "user",
            name: "Owner",
            width: 140,
        },
        "brightree_stop_hold.order_activity.currently_being_worked_by_id": {
            type: "user",
            name: "Open By",
            width: 140,
        },
        "brightree_stop_hold.order_activity.order_type": {
            type: "orderType",
            name: "Order Type",
            width: 120,
        },
        "brightree_stop_hold.order_activity.patient_id": {
            type: "string",
            name: "Patient ID",
            width: 120,
        },
        "brightree_stop_hold.order_activity.sales_location.region_id": {
            type: "region",
            name: "Region",
            width: 90,
        },
        "brightree_stop_hold.order_activity.sales_location_id": {
            type: "location",
            name: "Sales Location",
            width: 140,
        },
        "brightree_stop_hold.order_activity.service_location.field_operations_region_id": {
            type: "region",
            name: "Region",
            width: 90,
        },
        "brightree_stop_hold.order_activity.service_location_id": {
            type: "location",
            name: "Service Location",
            width: 150,
        },
        "brightree_stop_hold._queue_age_business": {
            type: "ageBusinessDays",
            name: "Age",
            width: 70,
        },
        "out_of_bounds": {
            type: "boolean",
            name: "OOB",
            width: 80,
        },
        "brightree_stop_hold.order_activity.insurance_type_id": {
            type: "insuranceType",
            name: "Pri Ins Type",
            width: 140,
        },
        "brightree_stop_hold.order_activity.insurance_sub_type_id": {
            type: "insuranceSubType",
            name: "Pri Payor",
            width: 140,
        },
        "brightree_stop_hold.branch_name": {
            type: "string",
            name: "Branch",
            width: 140,
        },
    };

    constructor(props) {
        super(props);

        this.state.dialogUpdateBrightreeStopHoldOpen = false;
        this.state.brightreeStopHoldNotes = [];
        this.state.isUploadingBrightreeStopHoldNote = false;
        this.state.brightreeStopHold = null;
        this.state.orderActivity = null;
        this.state.row = null;
    }


    /**
     * Updates the Brightree Stop Hold follow-up date, uploads the entered note
     * when an order activity is available, then reloads the queue and
     * closes the dialog.
     * @param {string} noteText The note text entered in the dialog.
     * @param {number} followupDays The number of business days until the next follow-up.
     */
    handleOnSaveBrightreeStopHoldUpdateChanges(noteText, followupDays) {
        const updatedBrightreeStopHoldFollowupDate =
            moment(Calendar.addDays({
                daysToAdd: followupDays,
                useBusinessDays: true,
            })).startOf("day").toISOString();


        const updatedBrightreeStopHold = {
            id: this.state.brightreeStopHold.id,
            salesOrderId: this.state.brightreeStopHold.salesOrderId,
            brightreeStopHoldTypeTermId: this.state.brightreeStopHold.brightreeStopHoldTypeTermId,
            brightreeStopHoldReasonTermId: this.state.brightreeStopHold.brightreeStopHoldReasonTermId,
            chargeAmount: this.state.brightreeStopHold.chargeAmount,
            allowableAmount: this.state.brightreeStopHold.allowableAmount,
            followupDate: updatedBrightreeStopHoldFollowupDate,
            createdAt: this.state.brightreeStopHold.createdAt,
            deleted: this.state.brightreeStopHold.deleted,
            deletedAt: this.state.brightreeStopHold.deletedAt,
            deletedById: this.state.brightreeStopHold.deletedById,
        };

        this.setState({
            isUploadingBrightreeStopHoldNote: true,
        });

        const updateBrightreeStopHoldPromises = [
            api.send("PUT", "/brightreeStopHold", updatedBrightreeStopHold),
        ];

        if (Boolean(noteText)) {
            updateBrightreeStopHoldPromises.push(api.send("POST", "/activities/" + this.state.orderActivity.id + "/notes", {
                orderActivityId: this.state.orderActivity.id,
                text: noteText,
                accountId: this.state.orderActivity.activity.accountId,
                completed: true,
                task: false,
                createdAt: new Date().toISOString(),
                activityId: this.state.orderActivity.activity.id,
                createdById: this.context.currentUser.id,
                noteTypeTermId: 270,
            }));
        }

        Promise.all(updateBrightreeStopHoldPromises)
            .then(() => {
                NotistackEnqueueSnackbar("Stop hold updated successfully!", { variant: "success" });
                this.setState({
                    isUploadingBrightreeStopHoldNote: false,
                    dialogUpdateBrightreeStopHoldOpen: false,
                    brightreeStopHold: null,
                    orderActivity: null,
                    row: null,
                    brightreeStopHoldNotes: [],
                });
                this.props.onReload();
            })
            .catch((error) => {
                console.error("Error updating stop hold:", error);
                NotistackEnqueueSnackbar("Error updating stop hold", { variant: "error" });
                this.setState({
                    isUploadingBrightreeStopHoldNote: false,
                });
            });
    }


    /**
     * Render the Update Brightree Stop Hold Dialog
     */
    renderInternal() {
        return (
            <DialogUpdateBrightreeStopHold
                open={this.state.dialogUpdateBrightreeStopHoldOpen}
                onClose={() => {
                    this.setState({
                        dialogUpdateBrightreeStopHoldOpen: false,
                        brightreeStopHold: null,
                        orderActivity: null,
                        row: null,
                        brightreeStopHoldNotes: [],
                    });
                }}
                onConfirm={(noteText, followupDays) => this.handleOnSaveBrightreeStopHoldUpdateChanges(noteText, followupDays)}
                row={this.state.row}
                orderActivity={this.state.orderActivity}
                brightreeStopHoldNotes={this.state.brightreeStopHoldNotes}
                loading={this.state.isUploadingBrightreeStopHoldNote}
            />
        )
    }

    /**
     * Handle clicking on a grid row.
     */
    handleClickRow(row) {
        this.setState({
            dialogUpdateBrightreeStopHoldOpen: true,
            row: row,
            brightreeStopHold: null,
            orderActivity: null,
            brightreeStopHoldNotes: [],
        });

        if (
            Boolean(row["brightree_stop_hold.id"])
        ) {
            api.send("GET", "/brightreeStopHold/" + row["brightree_stop_hold.id"])
                .then((brightreeStopHold) => {
                    if (
                        !this.state.dialogUpdateBrightreeStopHoldOpen
                        || this.state.row?.["brightree_stop_hold.id"] !== row["brightree_stop_hold.id"]
                    ) {
                        return;
                    }

                    this.setState({
                        brightreeStopHold: brightreeStopHold,
                    });
                })
                .catch((error) => {
                    console.error("Error fetching Brightree stop hold:", error);
                });
        }

        if (
            Boolean(row["brightree_stop_hold.order_activity.id"])
        ) {
            const selectedBrightreeStopHoldOrderActivityId = row["brightree_stop_hold.order_activity.id"];

            api.send("GET", "/order?id=" + selectedBrightreeStopHoldOrderActivityId)
                .then((orderActivity) => {
                    if (
                        !this.state.dialogUpdateBrightreeStopHoldOpen
                        || this.state.row?.["brightree_stop_hold.order_activity.id"] !== selectedBrightreeStopHoldOrderActivityId
                    ) {
                        return;
                    }

                    api.send("GET", "/activities/" + orderActivity.id + "/notes")
                        .then((notes) => {
                            if (
                                !this.state.dialogUpdateBrightreeStopHoldOpen
                                || this.state.row?.["brightree_stop_hold.order_activity.id"] !== selectedBrightreeStopHoldOrderActivityId
                            ) {
                                return;
                            }

                            const brightreeStopHoldNotes = notes.filter((note) =>
                                note.noteTypeTermId === 270
                            );
                            this.setState({
                                orderActivity: orderActivity,
                                brightreeStopHoldNotes: brightreeStopHoldNotes,
                            });
                        })
                        .catch((error) => {
                            console.error("Error fetching notes:", error);
                        });
                })
                .catch((error) => {
                    console.error("Error fetching order activity:", error);
                });
        }
    }

    /**
     * Get any applicable group summary items for the data grid. This is used to
     * add custom values to the grouping rows.
     */
    getGroupSummaryItems() {
        return [
            {
                columnName: "brightree_stop_hold.allowable_amount",
                type: "sum",
                showInGroupFooter: false,
                alignByColumn: true
            },
            {
                columnName: "brightree_stop_hold.charge_amount",
                type: "sum",
                showInGroupFooter: false,
                alignByColumn: true
            }
        ];
    }
}
